import React from 'react';

import { fetchBrandTheme, type BrandTheme } from '../brand-theme-api';

/** The brand's website theme for a composer's "Brand theme" swatches and Reset: null until it is read, and when the
 *  site has no readable theme (or there is no tenant). Shared by the Image Banners kit, HTML5 banner and mini-game
 *  composers. */
export const useBrandTheme = (tenantId: number | undefined): BrandTheme | null => {
  const [theme, setTheme] = React.useState<BrandTheme | null>(null);
  // Syncs with the network: reads the tenant's theme (cached per tenant by fetchBrandTheme).
  React.useEffect(() => {
    if (!tenantId) return undefined;
    let live = true;
    void fetchBrandTheme(tenantId).then((th) => {
      if (live) setTheme(th);
    });
    return () => {
      live = false;
    };
  }, [tenantId]);
  return theme;
};
